import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Overlay, Popover } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdOutlineClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import MonthlyCalendar from "../../../components/MonthlyCalendar";
import {
  setSelectedDate,
  setSelectedDateStatus,
  setStatusDates,
  useDates,
  useIsLoading,
  useLogs,
  useSelectedDate, useSelectedDateStatus, useStatusDates,
  useSuccess
} from "../../../redux/reducers/ExpLogReducer";
import { useRemovedUser } from "../../../redux/reducers/ProfileReducer";
import {
  setShowSidebar,
  useShowSidebar,
} from "../../../redux/reducers/SidebarReducer";
import { fetchDatedPendingLogs } from "../../../redux/sagas/experienceLog/fetchPendingByDateSaga";
import { fetchPendingDates } from "../../../redux/sagas/experienceLog/fetchPendingDatesSaga";
import { submitFlagLog } from "../../../redux/sagas/experienceLog/submitFlagSaga";
import { removeTraineeAction } from "../../../redux/sagas/trainees/deleteSaga";
import LocalStorage from "../../../services/LocalStorage";
import { LOG_DATA } from "../../../utils/CONSTANTS";
import { useDispatchEffect } from "../../../utils/hooks";
import "./style.scss";
import { getMonthDateRange } from "../../../utils/commonUtil";
// import { Popover } from 'react-tiny-popover';

const SignLogs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logs = useLogs();
  const dates = useDates();
  const statusDates = useStatusDates();
  const isLoading = useIsLoading();
  const success = useSuccess();
  const showSidebar = useShowSidebar();
  const selectedDate = useSelectedDate();
  const removedUsers = useRemovedUser();
  const [monthDate, setMonthDate] = React.useState(new Date());
  const [calenderSelectedDate, setCalenderSelectedDate] = React.useState(new Date());
  const filteredLogs = logs.filter(log => !removedUsers.includes(log.user?.id));
  
  const onDateChange = (date = new Date()) => {
    dispatch(setSelectedDate(date.toISOString()));
  };

  const tdRefs = new Array();
  filteredLogs.length &&
    filteredLogs.forEach((log) => {
      tdRefs.push(React.createRef());
    });

  useDispatchEffect(fetchPendingDates,{startDate:getMonthDateRange(monthDate).start,endDate:getMonthDateRange(monthDate).end}, monthDate);
  useDispatchEffect(
    fetchDatedPendingLogs,
    moment(selectedDate).format("YYYY-MM-DD"),
    selectedDate
  );
  
  useDispatchEffect(
    fetchDatedPendingLogs,
    moment(selectedDate).format("YYYY-MM-DD"),
    success
  );

  const approveLog = (id) => {
    dispatch(
      submitFlagLog({
        log_id: id,
        is_approved: true,
      })
    );
  };
  const logDetails = (log) => {
    LocalStorage.storeData(LOG_DATA, log);
    navigate(`/supervisor/log-details/${log.id}`);
  };
  const flagLog = (log) => {
    LocalStorage.storeData(LOG_DATA, log);
    navigate(`/supervisor/log-details/${log.id}?action=flag`);
  };
 
  useEffect(()=>{
    dispatch(setSelectedDate(moment(new Date()).toISOString()));
  },[])

  return (
    <div className="signLogs section has-light-background">
      <div className="columns ">
        <div className="column is-three-fifths">
          <button
            className="Toggle_btn"
            onClick={() => dispatch(setShowSidebar(!showSidebar))}
          >
            {showSidebar ? <GiHamburgerMenu /> : <GiHamburgerMenu />}
          </button>

          <p className="headingMain">Sign logs</p>

          <div className="column mt60 is-half">
            {dates && statusDates? (
              <MonthlyCalendar onChange={onDateChange} workdays={dates} statusDates={statusDates} monthDate={monthDate} setMonthDate={setMonthDate} selectedDate={calenderSelectedDate} setSelectedDate={setCalenderSelectedDate}/>
            ) : null}
          </div>

          <div className="column date-logs mt30">
            <p>{moment(selectedDate).format("MMMM DD, YYYY")} logs</p>
            <table className="Flagtable">
              <tr>
                <th>Student</th>
                <th>Task list items documented</th>
                <th> </th>
              </tr>

              {filteredLogs.map((log, i) => (
                <tr key={log.id}>
                  <td className="tableFlex" ref={tdRefs[i]}>
                    <span className="name">{log.user?.name}</span>
                    <DeleteItem
                      item={{ id: log.user?.id, name: log.user?.name }}
                      parent={tdRefs[i]}
                    />
                  </td>
                  <td>
                    {log.task?.map((t) => t.name.split(" ")[0]).join(", ")}
                  </td>
                  
                    <td style={{ paddingTop: 0 }}>
                    <div className="buttons">
                    {log.status!=='approved' &&<>
                      <button
                        className="text-button"
                        onClick={() => logDetails(log)}
                      >
                        Log Details
                      </button>
                      <button
                        className="primary-button"
                        onClick={() => approveLog(log.id)}
                      >
                        Approve
                      </button>
                      <button
                        className="secondary-button"
                        onClick={() => flagLog(log)}
                      >
                        Flag
                      </button>
                      </>}
                    </div>
                  </td>
                </tr>
              ))}
            </table>
            {isLoading && (
              <LoadingSpinner style={{ height: "100px", width: "100%" }} />
            )}
            {!isLoading && filteredLogs.length === 0 && (
              <div className="empty-list">No logs found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const DeleteItem = ({ item, parent }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };
  const removeUser = () => {
    dispatch(removeTraineeAction({ u_id: item.id }));
  };

  return (
    <div ref={ref} style={{ height: "20px" }}>
      <MdOutlineClose
        size={20}
        color="var(--color-primary)"
        onClick={handleClick}
      />

      <Overlay
        show={show}
        target={target}
        placement="bottom"
        container={ref}
        containerPadding={5}
      >
        <Popover id="popover-contained">
          <Popover.Body>
            <div className="delete-dialog">
              <p>Do you want to remove {item.name}?</p>
              <div className="row">
                <button className="primary-button" onClick={removeUser}>
                  Remove
                </button>
                <button
                  className="secondary-button"
                  onClick={() => {
                    setShow(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>

    // <Popover
    //   isOpen={isOpen}
    //   positions={['top', 'bottom', 'left', 'right']}  // if you'd like, you can limit the positions
    //   align='start'
    //   padding={2} // adjust padding here!
    //   reposition={false} // prevents automatic readjustment of content position that keeps your popover content within its parent's bounds
    //   onClickOutside={() => setIsOpen(false)} // handle click events outside of the popover/target here!
    //   parentElement
    //   content={({ position, nudgedLeft, nudgedTop }) => (
    //   )}
    //   >
    //   </Popover>
  );
};
export default SignLogs;
